const alertTypes = [
  { name: "base_flow", label: "Base flow", color: "#000" },
  { name: "leak_flow", label: "Leak alert", color: "#3422aa" },
  { name: "night_flow", label: "Night flow", color: "#0BA2B4" },
  { name: "data_loss", label: "Data loss", color: "#000" },
  { name: "peak_flow", label: "Peak flow", color: "#008D4B" },
  { name: "water_quality", label: "Water quality", color: "#C76500" },
  { name: "step_change", label: "Step change", color: "#3422aa" },
  { name: "pressure_flow", label: "Pressure alert", color: "#3422aa" },
  { name: "signal_strength", label: "Signal strength", color: "#3422aa" },
  { name: "low_temperature", label: "Low temperature", color: "#fffe1c" },
  { name: "high_temperature", label: "High temperature", color: "#e77457" },
  { name: "empty_pipe", label: "Empty pipe", color: "#68223f" },
  { name: "no_usage", label: "No usage", color: "#000" },
  { name: "low_battery", label: "Low battery", color: "#5cb85c" },
];

export default alertTypes;
